
import { useState, useMemo } from 'react';
import { AuditTrigger } from '@/types/audit';

export const useAuditTriggerFilter = (triggers: AuditTrigger[]) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('all');
  
  const filteredTriggers = useMemo(() => {
    return triggers.filter(trigger => {
      const matchesSearch = trigger.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                           trigger.description.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory = activeTab === 'all' || trigger.category === activeTab;
      return matchesSearch && matchesCategory;
    });
  }, [triggers, searchTerm, activeTab]);
  
  return {
    searchTerm,
    setSearchTerm,
    activeTab,
    setActiveTab,
    filteredTriggers
  };
};
